// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DaRj","label":"styles_label__26ag3"};